export enum SecondsPrefix {
  HOUR = 'hour',
  MINUTE = 'min',
  SECOND = 'second',
}
